module.exports = __webpack_public_path__ + "38aa6f054d3f5a4c97eb20aaf9a24f41.svg";